import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { navigateToPatientStep, navigateToShareRecommendation } from './actions/rapid-reco-steps.actions';
import { resetRapidRecoAllowance, setRapidRecoPatientFormValues, updateRapidRecoAllowance } from './actions/rapid-reco-patient.actions';
import { AppState } from '@app/store';
import { selectRapidRecoPetSummary } from './selectors/rapid-reco-patient.selectors';
import { PetInfo } from '@app/core/models';

@Injectable()
export class RapidRecoFacade {
  public rapidRecoPetSummary$: Observable<PetInfo> = this.store$.pipe(select(selectRapidRecoPetSummary));

  constructor(private readonly store$: Store<AppState>) {}

  setRapidRecoPatientFormValues(): void {
    this.store$.dispatch(setRapidRecoPatientFormValues());
  }

  updateRapidRecoAllowance(): void {
    this.store$.dispatch(updateRapidRecoAllowance());
  }

  resetRapidRecoAllowance(): void {
    this.store$.dispatch(resetRapidRecoAllowance());
  }

  navigateToPatientStep(isFromAllowanceParamPresent: boolean): void {
    this.store$.dispatch(navigateToPatientStep({ isFromAllowanceParamPresent }));
  }

  navigateToShareRecommendation(includePetProfileIntoPOLetter: boolean): void {
    this.store$.dispatch(navigateToShareRecommendation({ includePetProfileIntoPOLetter }));
  }
}
